function parseJson(value: string | null) {
  return value === null ? null : JSON.parse(value);
}

export function getSessionStorageValue<T = unknown>(
  key: string,
  deserializeFn: (value: string | null) => T = parseJson
): T | null {
  try {
    return deserializeFn(window.sessionStorage.getItem(key));
  } catch (e) {
    window.console.error(`Could not fetch [${key}] from sessionStorage`, e);
  }

  return null;
}

export function setSessionStorageValue<T>(
  key: string,
  value: T,
  serializeFn: (value: T) => string = JSON.stringify
): boolean {
  try {
    window.sessionStorage.setItem(key, serializeFn(value));
    return true;
  } catch (e) {
    window.console.error(`Could not set [${key}] in sessionStorage`, e);
  }

  return false;
}

export function removeSessionStorageValue(key: string): boolean {
  try {
    window.sessionStorage.removeItem(key);
    return true;
  } catch (e) {
    window.console.error(`Could not remove [${key}] from sessionStorage`, e);
  }

  return false;
}
